import { render, staticRenderFns } from "./SplitTrackingBadge.vue?vue&type=template&id=a38aab50&scoped=true&"
import script from "./SplitTrackingBadge.vue?vue&type=script&lang=js&"
export * from "./SplitTrackingBadge.vue?vue&type=script&lang=js&"
import style0 from "./SplitTrackingBadge.vue?vue&type=style&index=0&id=a38aab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38aab50",
  null
  
)

export default component.exports